import { RouterStore, ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";
// import { utils } from 'shared/intrasyncUtils';

const fabricationSequenceRoute: RouteType[] = [
  {
    name: "Fabrication Sequence",
    path: "/job/:jobNumber/fabrication-sequence",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Fabrication Sequence",
        // component: () => import('./FabricationSequence.Header'), // Assuming a header component exists
        enableToolbox: true,
        enableBackButton: true,
        enableRefreshButton: true,
      },
      body: {
        // component: () => import('./FabricationSequence.Body'),
        // grayBackground: true, // Add if needed
        gridContainer: {
          namespace: "FabricationSequenceDataGrid",
          storeName: "fabricationSequenceStore",
          // customEntity: 'qrCodeRows',
          // fixedRowCount: 2,
          columnHeaders: [
            {
              width: 200,
              title: "Control Number",
              key: "controlNumber",
            },
            {
              width: 200,
              title: "Mark Number",
              key: "markNumber",
            },
            {
              width: 200,
              title: "Series Number",
              key: "series",
            },
            {
              width: 200,
              title: "Mold Number",
              key: "moldNumber",
            },
            {
              width: 200,
              title: "Fabrication Sequence",
              key: "fabricationSequence",
            },
            {
              width: 200,
              title: "Installation Sequence",
              key: "installationSequence",
            },
            {
              width: 200,
              title: "Elevation",
              key: "elevation",
            },
          ],
          defaultSort: {
            sortBy: ["controlNumber"],
            sortDirection: { controlNumber: "ASC" },
          },
          onRowClick: () => console.log("Clicked"),
          // onRowClick: ({ controlUUID }) =>
          // openDialog({
          //   dialogName: 'QR Code',
          //   dialogContext: controlUUID
          // })
        },
      },
    },
    group: 'Production',
  requiresAuth: true, // Assuming auth is required
    requiresPermission: false,
    permissionPath: "/app/fabrication-sequence", // Keep for consistency
    // defaultQueryParams: {
    //   productType: `job-stats/panel-count/:jobNumber`,
    // },
    projectRoute: true,
    // channels: [
    //   'job/:jobNumber',
    //   'job-plant/:jobNumber',
    //   'panel-revit/:jobNumber',
    //   'panel-plant/:jobNumber',
    //   'panel-yard/:jobNumber',
    // ],
    channels: [
      "job/:jobNumber",
      "job/:jobNumber",
      "panel-revit/:jobNumber",
      "panel-plant/:jobNumber",
      "panel-yard/:jobNumber",
    ],
    onEnter: async ({ rootStore }) => {
      const routerStore = rootStore.routerStore;
      const panelStore = rootStore.panelStore as ServiceStore;
      const { params } = routerStore as RouterStore;
      panelStore?.find({ query: { jobNumber: params.jobNumber } });
    },
    enableAutoFind: false,
    // onParamsChange: async ({
    //   rootStore,
    //   params,
    //   queryParams,
    //   previousParams,
    //   previousQueryParams,
    // }) => {
    //   if (
    //     queryParams?.productType !== previousQueryParams.productType ||
    //     !utils.isSameJobNumber(params?.jobNumber, previousParams.jobNumber)
    //   )
    //     rootStore.routerStore.triggerEnterSideEffects();
    // },
  },
];

export default fabricationSequenceRoute;
